import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kbutton = _resolveComponent("kbutton")!
  const _component_buttongroup = _resolveComponent("buttongroup")!

  return (_openBlock(), _createBlock(_component_buttongroup, {
    class: "single-select-action-buttons",
    width: "350px",
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelection($event)))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insight.controller.options, (option, index) => {
        return (_openBlock(), _createBlock(_component_kbutton, {
          key: index,
          value: _ctx.t(`config.insight.observation.singleSelect.${option}`),
          selected: _ctx.selected === _ctx.t(`config.insight.observation.singleSelect.${option}`),
          togglable: true,
          size: 'small',
          disabled: _ctx.disabled,
          type: "button",
          class: "single-select-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t(`config.insight.observation.singleSelect.${option}`)), 1)
          ]),
          _: 2
        }, 1032, ["value", "selected", "disabled"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["disabled"]))
}